import { EstopStateEnum } from './estopStateEnum';

import {
  listenToEstop,
  reconnectEstopModalCallback,
  replaceEstopCallback,
  getLastEstopState,
  refreshEstopModal,
} from './estopManager';

// estopManager is shared to the VSE and includes EstopStateEnum
// I don't think this is how it should be done, but it is what it is
// TODO GD Review this later
export const estopManager = {
  EstopStateEnum,
  listenToEstop,
  reconnectEstopModalCallback,
  replaceEstopCallback,
  getLastEstopState,
  refreshEstopModal,
};

export { EstopStateEnum };
